import { makeSubmission } from 'src/main/factories/pages'

export default makeSubmission
